import { FormBase } from 'core/components';

export default class PatientInsuranceEditModalForm extends FormBase {
    constructor(hooks) {
        super(hooks);
    }

    setup() {
        return {
            fields: [
                {
                    name: 'primaryInsuranceName',
                    label: 'Insurance',
                    placeholder: 'Select Insurance'                   
                },
                {
                    name: 'primaryInsurancePolicyNumber',
                    label: 'Insurance Policy Number',
                    placeholder: 'Enter Insurance Policy Number'           
                },
                {
                    name: 'primaryInsuranceStartDate',
                    label: 'Start Date',
                    placeholder: ''                  
                },
                {
                    name: 'secondaryInsuranceEndDate',
                    label: 'End Date',
                    placeholder: ''                
                },
                {
                    name: 'secondaryInsuranceName',
                    label: 'Insurance',
                    placeholder: 'Select Insurance Name'                   
                },
                {
                    name: 'secondaryInsurancePolicyNumber',
                    label: 'Insurance Policy Number',
                    placeholder: 'Enter Insurance Policy Number'                   
                },
                {
                    name: 'secondaryInsuranceGroupNumber',
                    label: 'Insurance Group Number',
                    placeholder: 'Enter Insurance Group Number'                   
                },
                {
                    name: 'secondaryInsuranceStartDate',
                    label: 'Start Date',
                    placeholder: ''                  
                },
                {
                    name: 'oldPrimaryInsuranceName',
                    label: 'Insurance',
                    placeholder: 'Select Insurance Name'                   
                },
                {
                    name: 'oldPrimaryInsurancePolicyNumber',
                    label: 'Insurance Policy Number',
                    placeholder: 'Enter Insurance Policy Number'           
                },
                {
                    name: 'oldPrimaryInsuranceStartDate',
                    label: 'Start Date',
                    placeholder: ''                
                },
                {
                    name: 'oldPrimaryInsuranceEndDate',
                    label: 'End Date',
                    placeholder: ''                
                }
            ],
        };
    }
}
